// extracted by mini-css-extract-plugin
export default {"terms-content":"Terms_terms-content__3B3XK"};